'use client';

import React from 'react';
import { Card } from 'src/components/PulseUI';
import WidgetHeader from 'src/components/Profiles/shared/widgets/WidgetHeader';
import CodeSetVolumeGapV2 from './CodeSetVolumeGapV2';

const CompactVolumeGap: React.FC = () => {
  return (
    <Card
      className="p-5 flex flex-col gap-3 bg-white h-full"
      data-testid="compact-volume-gap"
      role="region"
    >
      <WidgetHeader fallbackTitle="Gap Analysis" />
      <div className="flex-1 min-h-0 overflow-y-auto">
        <CodeSetVolumeGapV2 />
      </div>
    </Card>
  );
};

export default CompactVolumeGap;
